/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'
import DatePicker from '../../common/DatePicker'
import SimplePhotoUploader from '../../common/SimplePhotoUploader'
import PropTypes from 'prop-types'

import './ChallengeForm.scss'

const ChallengeForm = ({
  name,
  points,
  startDate,
  endDate,
  video_url,
  description,
  handleInputChange,
  handleStartChange,
  handleEndChange,
  grabPhotoData,
  grabIconData,
  selectedPhoto,
  selectedIcon,
  failedValidation,
  submitClicked,
  handleSubmitClick,
  links,
  addNewLink,
  removeLink,
  handleDisplayName,
  handleLinkUrl,
  isEdit,
}) => { // eslint-disable-line arrow-body-style
  const { t } = useTranslation()
  return (
    <div id='ChallengeForm'>
      <div className='challenge-inner-form'>
        <div className='challenge-form-top-container'>
          <div
            className={`challenge-photo-area ${failedValidation.includes(
              'photo'
            ) ? 'failed-validation' : ''}`}
          >
            <p className='ml-2'>
              {t('challenges.form.headerPhoto')}<span className='required-field'>*</span>
              {isEdit && (
                <span className='subtext'>
                  {t('challenges.form.subtextEditPhoto')}
                </span>
              )}
            </p>
            <SimplePhotoUploader
              sendPhotoData={grabPhotoData}
              selectedPhoto={selectedPhoto}
            />
          </div>
          <div className='challenge-form-name-area'>
            <p>
              {t('common.field.name')}<span className='required-field'>*</span>
            </p>
            <input
              type='text'
              value={name}
              name='name'
              onChange={handleInputChange}
              className={
                failedValidation.includes('name') ? 'failed-validation' : ''
              }
            />
            <p>
              {t('challenges.form.points')}<span className='required-field'>*</span>
            </p>
            <input
              type='number'
              value={points}
              name='points'
              onChange={handleInputChange}
              onWheel={(e) => e.target.blur()}
              className={
                failedValidation.includes('points') ? 'failed-validation' : ''
              }
            />
            <div className='date-box-container'>
              <div className='date-box'>
                <p>{t('common.field.startDate')}</p>
                <DatePicker selected={startDate} onChange={handleStartChange} />
              </div>
              <div className='date-box'>
                <p>{t('common.field.endDate')}</p>
                <DatePicker selected={endDate} onChange={handleEndChange} />
              </div>
            </div>
          </div>
        </div>
        <div className='challenge-form-bottom-container'>
          <div
            className={`challenge-form-icon-loader-container ${failedValidation.includes(
              'icon'
            ) ? 'failed-validation' : ''}`}
          >
            <p className='ml-2'>
              {t('challenges.form.iconImage')}<span className='required-field'>*</span>
            </p>
            <SimplePhotoUploader
              sendPhotoData={grabIconData}
              selectedPhoto={selectedIcon}
              second={true}
            />
          </div>
          <div className='challenge-form-detail-area'>
            <p className='mt-2'>{t('challenges.form.videoUrl')}</p>
            <input
              type='text'
              value={video_url}
              name='video_url'
              onChange={handleInputChange}
            />
            <p className='mt-2'>
              {t('common.field.description')}<span className='required-field'>*</span>
            </p>
            <textarea
              value={description}
              name='description'
              onChange={handleInputChange}
              className={
                failedValidation.includes('description') ? 'failed-validation' : ''
              }
            />
          </div>
        </div>
        {failedValidation.length > 0 && (
          <div className='failed-validation-box'>
            <p>{t('challenges.form.validationMessage', { fields: failedValidation.map(id => t(`challenges.form.fieldName.${id}`)).join(', ') })}</p>
          </div>
        )}
        <div className='links-container'>
          {links.length > 0
            ? links.map((link, i) => (
              <div key={i} className='single-link-card'>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <div
                  className='remove-link-card'
                  onClick={() => removeLink(i)}
                >
                  <i className='fa fa-trash' aria-hidden='true' />
                </div>
                <p>{t('challenges.form.displayName')}</p>
                <input
                  type='text'
                  value={link.display_name}
                  name='link-display-name'
                  onChange={e => handleDisplayName(e, i)}
                />
                <p>{t('challenges.form.linkUrl')}</p>
                <input
                  type='text'
                  value={link.link_url}
                  name='link-display-name'
                  onChange={e => handleLinkUrl(e, i)}
                />
              </div>
            ))
            : null}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
          <p className='add-link-button text-center' onClick={addNewLink}>
            {t('challenges.form.addLink')}
          </p>
        </div>
        <div className='challenge-form-submit-container'>
          <button
            className='challenge-submit-button'
            onClick={handleSubmitClick}
            disabled={submitClicked}
          >
            {submitClicked ? (
              <i className='fa fa-spinner fa-spin' aria-hidden='true' />
            ) : null}
            {t(isEdit
              ? (submitClicked ? 'challenges.form.editingChallenge' : 'challenges.form.editChallenge')
              : (submitClicked ? 'challenges.form.addingChallenge' : 'challenges.form.addChallenge'))}
          </button>
        </div>
      </div>
    </div>
  )
}

ChallengeForm.propTypes = {
  isEdit: PropTypes.bool,
}

export default ChallengeForm
